import { twMerge } from "tailwind-merge";
import { Badge } from "../../../../../../components/ui/Badge";

export function TransactionBadgeStatus({ status }) {
  return (
    <Badge.Root
      style={{ background: status.color }}
      className={twMerge("w-full border [&>*]:!text-white [&>*]:!font-semibold")}>
      <Badge.Text>{status.text}</Badge.Text>
    </Badge.Root>
  )
}
